import { checkIcon } from "../../core/elements/icons/index.js";
import { widget } from "@foretagsplatsen/widgetjs";
import OldSpinnerWidget from "../../deprecated/OldSpinnerWidget/OldSpinnerWidget.js"; // eslint-disable-line import-x/no-deprecated -- todo: migrate to new spinner

/**
 * `updatingTitleWidget` is a title providing some subtle feedback about
 * updating process
 */
function updatingTitleWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = widget(spec, my);

	const title = spec.title || "";

	let pending = false;
	let succeeded = false;

	// eslint-disable-next-line import-x/no-deprecated -- todo: migrate to new spinner
	my.spinner = new OldSpinnerWidget({
		size: 18,
		dark: true,
	});

	my.spinner.show();

	that.pend = function () {
		pending = true;
		succeeded = false;
		that.update();
	};

	that.succeed = function () {
		succeeded = true;
		pending = false;
		that.update();

		setTimeout(() => {
			succeeded = false;
			that.asJQuery().find(".visible-kpis-updated").addClass("invisible");
		}, 1000);
	};

	that.renderContentOn = function (html) {
		html.div({ klass: "updating-title" }).render((html) => {
			html.div({ klass: "inline-block" }, title);
			if (pending) {
				html.div({ klass: "spinner inline-block" }, my.spinner);
			}
			if (succeeded) {
				html.span(
					{ klass: "visible-kpis-updated inline-block" },
					checkIcon,
				);
			}
		});
	};

	return that;
}

export default updatingTitleWidget;
